import {
  StatisticsActionTypes,
  IGetCreditUsagePayload,
  IGetProjectCreationPayload,
  IGetCreditUsageSuccessResponseBody,
  IGetProjectCreationSuccessResponseBody,
} from './types'

export const getCreditUsage = (payload: IGetCreditUsagePayload) => ({
  type: StatisticsActionTypes.GET_CREDIT_USAGE,
  payload,
})

export const getCreditUsageSuccess = (payload: IGetCreditUsageSuccessResponseBody) => ({
  type: StatisticsActionTypes.GET_CREDIT_USAGE_SUCCESS,
  payload,
})

export const getCreditUsageFailure = () => ({
  type: StatisticsActionTypes.GET_CREDIT_USAGE_FAILURE,
})

export const getProjectCreation = (payload: IGetProjectCreationPayload) => ({
  type: StatisticsActionTypes.GET_PROJECT_CREATION,
  payload,
})

export const getProjectCreationSuccess = (payload: IGetProjectCreationSuccessResponseBody) => ({
  type: StatisticsActionTypes.GET_PROJECT_CREATION_SUCCESS,
  payload,
})

export const getProjectCreationFailure = () => ({
  type: StatisticsActionTypes.GET_PROJECT_CREATION_FAILURE,
})
